import React from 'react';

import cn from 'classnames';

import { Flex, Skeleton } from '@shared/ui';

import cls from './Loader.module.css';

interface LoaderProps {
    classes?: string;
}

export const Loader = ({ classes }: LoaderProps) => (
    <div className={cn(cls.LoaderWrapper)}>
        {Array.from({ length: 6 }).map((_, i) => (
            <div className={cn(cls.row, classes)}>
                <Skeleton height={16} width="100%" />
                <Skeleton height={16} width="100%" />
                <Skeleton height={16} width="100%" />
                <Skeleton height={16} width="100%" />
                <Skeleton height={16} width="100%" />
                <Skeleton height={16} width="100%" />
                <Skeleton height={16} width="100%" />
            </div>
        ))}
    </div>
);
